module.exports = __webpack_public_path__ + "static/AvenirLTProBook-8f093ea16d2774df19a494906d2976e6.woff";